package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class CustomRoleRepository(private val httpClient: HttpClient) {
    suspend fun getRoles(workplaceId: Long): Result<List<CustomRoleDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/roles").body()
    }

    suspend fun createRole(workplaceId: Long, name: String): Result<Long> = runCatching {
        httpClient.post("workplaces/$workplaceId/roles") {
            setBody(CreateCustomRoleRequest(name))
        }.body<Map<String, Long>>()["id"]!!
    }

    suspend fun deleteRole(workplaceId: Long, roleId: Long): Result<Unit> = runCatching {
        httpClient.delete("workplaces/$workplaceId/roles/$roleId")
    }

    suspend fun assignRoles(workplaceId: Long, userId: Long, roleIds: List<Long>): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/staff/$userId/roles") {
            setBody(AssignRolesRequest(roleIds))
        }
    }
}
